import { Pipe, PipeTransform } from '@angular/core';

import { htmlToText } from '../utils';

@Pipe({
  name: 'htmlToText',
})
export class HtmlToTextPipe implements PipeTransform {
  transform(value?: string): string {
    return htmlToText(value);
  }
}
